// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#navBar{
    border: 1px solid black;
    height: fit-content;
    
}
#navBarColor{
    background-color: white !important;
    box-shadow: 0 2px 12px 0 #24324233;
    padding: 0px !important;
}
.navbar-logo{
    width: 130px !important;
    margin-left: -25px !important;
}
.navbar-logo:hover{
    cursor: pointer;
}


.ui.secondary.inverted.menu .active.item,
.ui.secondary.inverted.menu a.item:hover{
    color: #e85726 !important;
    cursor: pointer;
}

.ui.secondary.inverted.menu .item:hover{
    color: #e85726 !important;
    cursor: pointer;
}

.px-5 {
    padding: 5px !important;
}
.mt-10{
    margin-top: 10px !important;
}
.ml-20{
    margin-left: 20px !important;
}


.ui.secondary.inverted.menu a.item {
    color: #1c2640 !important;
    opacity: unset;
    text-align: center;
}

.ui.secondary.inverted.menu a.white.right.item{
    color: #fff !important;
}
.ui.secondary.inverted.menu a.white.right.item:hover{
    color: #F9FBFF !important;
    background-color: #FD7603 !important;
}

.ui.secondary.inverted.menu {
    height: 100%;
    max-width: 1420px;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;
    padding: 0 64px;
}

.ui.secondary.inverted.menu > .grouped-menu{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    height: 100%;
}

.ui.secondary.inverted.menu .dropdown.item{
    color: #1c2640 !important;
    font-size: 15px;
    font-weight: 500;
    transition: all .15s linear;
}

.ui.secondary.inverted.menu .dropdown.menu-item{
    color: #1c2640 !important;
    font-size: 14px;
    font-weight: 500;
    transition: all .15s linear;
    margin-right: 10px;
}

.ui.secondary.inverted.menu .dropdown.item:hover, 
.ui.secondary.inverted.menu .link.item:hover, 
.ui.secondary.inverted.menu a.item:hover {
    color: #fd7603 !important;
}

.menu-item-has-children .sub-menu{
    visibility: hidden;
}


.ui.inverted.secondary.menu >.menu-item-has-children:hover>.ui.item.dropdown:before{
    width: 100%;
    transition: width .15s ease-in;
}

.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown:before{
    content: "";
    width: 0;
    height: 3px;
    background: #FD7603;
    bottom: -3px;
    top: auto;
    position: absolute;
    

}


.ui.inverted.secondary.menu >.menu-item-has-children:hover>.ui.item.dropdown>.sub-menu{
    opacity: 1;
    visibility: visible;

}

.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu{
    visibility: hidden;
    list-style: none;
    display: flex;
    flex-flow: wrap;
    position: absolute;
    margin-left: -25px;
    opacity: 0;
    background-color: #fff;
    margin-top: 20px;
    transition: all .15s ease-in-out;
    box-shadow: 0 0 48px rgba(113, 122, 137, 0.25);
    border-radius: 6px;
    padding: 30px 30px 0;
    justify-content: space-between;
    flex-direction: row;
    border: 1px solid #ddd;
}

.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu.product{
    width: 230px;
}
.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu.solutions,
.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu.platform{
    width: 500px;
}
.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu.resources{
    width: 250px;
}

.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu>li.left,
.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu>li.right{
    width: 47%;
}

.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu>li a{
    width: 100%;
    display: block;
    font-stretch: normal;
    color: #1C2640;
    margin: 0;
    padding: 0!important;
    transition: all .15s linear;
    font-family: Roboto;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0em;
    text-align: left;

}

.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu li a:hover{
    color: #FD7603 !important;
    font-weight: 600;
}

.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu>li .highlight-box{
    margin: 8px 0 25px;
    font-size: 13px;
    line-height: 1.36;
    font-family: Roboto;
    font-weight: 400;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #52667C;
    padding-top: 0;
    display: block;

    
} 

/*.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu.product>li .highlight-box{
    width: 100%;
}
.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu.solutions>li .highlight-box{
    width: 95%;
}*/

.ui.menu .dropdown.item .menu {
    background: #fff!important;
    margin-top: 17px;
    width: 250px;
}
.ui.menu .dropdown.item .menu.visible{
    padding: 0px 10px 10px 15px !important;
}

.ui.menu .dropdown.item .menu.visible.multi-column-menu{
    display: flex !important;
    width: 520px !important;
    flex-flow: wrap;
    padding: 10px 0px 20px 20px !important;
}

.ui.menu .dropdown.item .menu.visible.flex-menu{
    display: flex !important;
    width: 520px !important;
    flex-direction: row;
    padding: 10px 0px 20px 20px !important;
}
.ui.menu .dropdown.item .menu.visible.flex-menu>.left{
    display: flex !important;
    flex-direction: column;
    margin-top: -10px;
}

.ui.menu .dropdown.item .menu.visible.multi-column-menu .custom-msg-nav{
    width: 210px !important;
}

.ui.menu .ui.dropdown .menu>.item {
    font-size: 13px !important;
    padding: 10px !important;
    background: 0 0!important;
    color: #fff !important;
    font-weight: 500!important;
    margin-right: 20px;
}

.ui.secondary.menu .dropdown.item>.menu {
    border-radius: 0px;
    border: unset;
    transition: all 0.3s ease-in-out 0s, visibility 0s linear 0.3s, z-index 0s linear 0.01s;
}

.ui.menu .ui.dropdown .menu>.item:hover {
    background: #fff !important;
    color: #fff !important;
    border-radius: 0 !important;
}
.ui.menu .ui.dropdown .menu>.left>.item:hover {
    background: #fff !important;
    color: #fff !important;
    border-radius: 0 !important;
}
.ui.menu .ui.dropdown .menu>.right>.item:hover {
    background: #fff !important;
    color: #fff !important;
    border-radius: 0 !important;
}
.ui.menu .ui.dropdown .menu>.active.item{
/*    background: #FD7603 !important;*/
    font-weight: 700 !important;
    color: #fff !important;
    border-radius: 0 !important;
}

.ui.menu .ui.dropdown .menu>.left>.active.item {
/*    background: #FD7603 !important;*/
    font-weight: 700 !important;
    color: #fff !important;
    border-radius: 0 !important;
}

.ui.menu .ui.dropdown .menu>.right>.active.item {
/*    background: #FD7603 !important;*/
    font-weight: 700 !important;
    color: #fff !important;
    border-radius: 0 !important;
}


.ui.menu .ui.dropdown .menu>.active.item > .custom-msg-nav>.content>.header {
    color: #fd7603 !important;
}

.ui.menu .ui.dropdown .menu>.left>.active.item > .custom-msg-nav>.content>.header {
    color: #fd7603 !important;
}
.ui.menu .ui.dropdown .menu>.right>.active.item > .custom-msg-nav>.content>.header {
    color: #fd7603 !important;
}

.ui.secondary.inverted.menu a.item.contact-us {
    color: #fff !important;
    font-weight: 700px !important;
}

.ui.secondary.inverted.menu a.item.contact-us:hover {
    color: #F9FBFF !important;
    background-color: #FD7603 !important;
}

.ui.secondary.inverted.menu .active.item >.ui.item.dropdown{
    color: #e85726 !important;
}
.ui.inverted.menu .item>.nav-list-text:before{
    background-color: #fafaf9;
    content: "";
    position: absolute;
    border-radius: 3px;
    width: calc(100% - 20px);
    height: calc(100% - 10px);
    top: 5px;
    left: 10px;
    background: #edf1f2;
    z-index: -1;
    opacity: 0;
    transform: scale(1.1);
    transition: opacity .2s ease-in-out,transform .2s ease-in-out;
}

/*.ui.inverted.menu .item>.nav-list-text:focus,
.ui.inverted.menu .item>.nav-list-text:before {
    opacity: 1;
    transform: scale(1);
}*/


.ui.item.dropdown.menu-item:after {
    content: '';
    display: block;
    margin: auto;
    height: 3px;
    width: 0px;
    margin-top: 10px;
    margin-bottom: -12px;
    background: transparent;
    transition: width .5s ease, background-color .5s ease;
}
.ui.active.visible.item.dropdown.menu-item:after {
    width: 100%;
    background: #fd7603;
}
.ui.menu .item>i.dropdown.icon {
    float: right;
    margin-left: 5px !important;
}

.ui.menu .item>i.icon {
    opacity: .75;
    float: none;
    margin: 0 15px 0 0;
}

.icon-menu-list, .mobile-view{
    display: none;
}

.animate {
  animation-duration: 0.4s;
  animation-fill-mode: both;
}


@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(300px);
  }
  to {
    opacity: 1;
  }
}

.fadeInDown {
  animation-name: fadeInDown;
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    transform: translate3d(0, -100%, 20);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}



.custom-msg-nav{
    background: #fff !important;
    box-shadow: unset !important;
    transform: scale(1.1);
    transition: opacity 80ms linear,transform 80ms ease-in;
    padding: 10px;
    width: 200px;
    word-wrap: break-word;
    white-space: pre-wrap;
}
.custom-msg-nav>.content>.header{
    font-size: 14px !important;
    margin-bottom: 0px !important;
}
.custom-msg-nav>.content>p{
    display: inline-block !important;
    font-size: 12px !important;
    font-weight: 400 !important;
    line-height: 1.6 !important;
    color: #222b37 !important;
}
.custom-msg-nav>.content:before{
    content: "";
    position: absolute;
    border-radius: 3px;
    width: calc(100% + 8px);
    height: calc(100% + 8px);
    top: -4px;
    left: -4px;
    background: #fafaf9;
    z-index: -1;
    opacity: 0;
    transform: scale(1.1);
    transition: opacity 80ms linear,transform 80ms ease-in;
}

.custom-msg-nav>.content:hover:before {
    opacity: 1;
    transform: scale(1);
    transition: opacity .2s linear,transform .2s ease-out;
}
.custom-msg-nav>.content:hover>.header{
    color: #fd7603 !important;
}
.navigation__scrim.active {
    opacity: 0.2;
    pointer-events: all;
}

.ui.secondary.inverted.menu .active.dropdown.menu-item{
    color: #e85726 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/NavBar/navBar.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,mBAAmB;;AAEvB;AACA;IACI,kCAAkC;IAClC,kCAAkC;IAClC,uBAAuB;AAC3B;AACA;IACI,uBAAuB;IACvB,6BAA6B;AACjC;AACA;IACI,eAAe;AACnB;;;AAGA;;IAEI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,4BAA4B;AAChC;;;AAGA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT,kBAAkB;;;AAGtB;;;AAGA;IACI,UAAU;IACV,mBAAmB;;AAEvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,gBAAgB;IAChB,gCAAgC;IAChC,8CAA8C;IAC9C,kBAAkB;IAClB,oBAAoB;IACpB,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;AACA;;IAEI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,cAAc;IACd,SAAS;IACT,oBAAoB;IACpB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;;AAEpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,cAAc;IACd,cAAc;IACd,cAAc;;;AAGlB;;AAEA;;;;;EAKE;;AAEF;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,mBAAmB;IACnB,sCAAsC;AAC1C;AACA;IACI,wBAAwB;IACxB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;IAC1B,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uFAAuF;AAC3F;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;AACA,sCAAsC;IAClC,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;AACA,sCAAsC;IAClC,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;AACA,sCAAsC;IAClC,2BAA2B;IAC3B,sBAAsB;IACtB,2BAA2B;AAC/B;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;IACzB,QAAQ;IACR,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,6DAA6D;AACjE;;AAEA;;;;EAIE;;;AAGF;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;IACvB,qDAAqD;AACzD;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;EAEE,wBAAwB;EAExB,yBAAyB;AAC3B;;;AAGA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EAEE,0BAA0B;AAC5B;;AAeA;EACE;IACE,UAAU;IAEV,oCAAoC;EACtC;EACA;IACE,UAAU;IAEV,eAAe;EACjB;AACF;;;;AAIA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,qBAAqB;IACrB,sDAAsD;IACtD,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;AACA;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,2BAA2B;IAC3B,2BAA2B;IAC3B,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,qBAAqB;IACrB,sDAAsD;AAC1D;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,qDAAqD;AACzD;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["#navBar{\n    border: 1px solid black;\n    height: fit-content;\n    \n}\n#navBarColor{\n    background-color: white !important;\n    box-shadow: 0 2px 12px 0 #24324233;\n    padding: 0px !important;\n}\n.navbar-logo{\n    width: 130px !important;\n    margin-left: -25px !important;\n}\n.navbar-logo:hover{\n    cursor: pointer;\n}\n\n\n.ui.secondary.inverted.menu .active.item,\n.ui.secondary.inverted.menu a.item:hover{\n    color: #e85726 !important;\n    cursor: pointer;\n}\n\n.ui.secondary.inverted.menu .item:hover{\n    color: #e85726 !important;\n    cursor: pointer;\n}\n\n.px-5 {\n    padding: 5px !important;\n}\n.mt-10{\n    margin-top: 10px !important;\n}\n.ml-20{\n    margin-left: 20px !important;\n}\n\n\n.ui.secondary.inverted.menu a.item {\n    color: #1c2640 !important;\n    opacity: unset;\n    text-align: center;\n}\n\n.ui.secondary.inverted.menu a.white.right.item{\n    color: #fff !important;\n}\n.ui.secondary.inverted.menu a.white.right.item:hover{\n    color: #F9FBFF !important;\n    background-color: #FD7603 !important;\n}\n\n.ui.secondary.inverted.menu {\n    height: 100%;\n    max-width: 1420px;\n    display: flex;\n    flex-wrap: nowrap;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin: 0 auto;\n    padding: 0 64px;\n}\n\n.ui.secondary.inverted.menu > .grouped-menu{\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    height: 100%;\n}\n\n.ui.secondary.inverted.menu .dropdown.item{\n    color: #1c2640 !important;\n    font-size: 15px;\n    font-weight: 500;\n    transition: all .15s linear;\n}\n\n.ui.secondary.inverted.menu .dropdown.menu-item{\n    color: #1c2640 !important;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all .15s linear;\n    margin-right: 10px;\n}\n\n.ui.secondary.inverted.menu .dropdown.item:hover, \n.ui.secondary.inverted.menu .link.item:hover, \n.ui.secondary.inverted.menu a.item:hover {\n    color: #fd7603 !important;\n}\n\n.menu-item-has-children .sub-menu{\n    visibility: hidden;\n}\n\n\n.ui.inverted.secondary.menu >.menu-item-has-children:hover>.ui.item.dropdown:before{\n    width: 100%;\n    transition: width .15s ease-in;\n}\n\n.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown:before{\n    content: \"\";\n    width: 0;\n    height: 3px;\n    background: #FD7603;\n    bottom: -3px;\n    top: auto;\n    position: absolute;\n    \n\n}\n\n\n.ui.inverted.secondary.menu >.menu-item-has-children:hover>.ui.item.dropdown>.sub-menu{\n    opacity: 1;\n    visibility: visible;\n\n}\n\n.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu{\n    visibility: hidden;\n    list-style: none;\n    display: flex;\n    flex-flow: wrap;\n    position: absolute;\n    margin-left: -25px;\n    opacity: 0;\n    background-color: #fff;\n    margin-top: 20px;\n    transition: all .15s ease-in-out;\n    box-shadow: 0 0 48px rgba(113, 122, 137, 0.25);\n    border-radius: 6px;\n    padding: 30px 30px 0;\n    justify-content: space-between;\n    flex-direction: row;\n    border: 1px solid #ddd;\n}\n\n.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu.product{\n    width: 230px;\n}\n.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu.solutions,\n.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu.platform{\n    width: 500px;\n}\n.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu.resources{\n    width: 250px;\n}\n\n.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu>li.left,\n.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu>li.right{\n    width: 47%;\n}\n\n.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu>li a{\n    width: 100%;\n    display: block;\n    font-stretch: normal;\n    color: #1C2640;\n    margin: 0;\n    padding: 0!important;\n    transition: all .15s linear;\n    font-family: Roboto;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 18px;\n    letter-spacing: 0em;\n    text-align: left;\n\n}\n\n.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu li a:hover{\n    color: #FD7603 !important;\n    font-weight: 600;\n}\n\n.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu>li .highlight-box{\n    margin: 8px 0 25px;\n    font-size: 13px;\n    line-height: 1.36;\n    font-family: Roboto;\n    font-weight: 400;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    color: #52667C;\n    padding-top: 0;\n    display: block;\n\n    \n} \n\n/*.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu.product>li .highlight-box{\n    width: 100%;\n}\n.ui.inverted.secondary.menu >.menu-item-has-children>.ui.item.dropdown>.sub-menu.solutions>li .highlight-box{\n    width: 95%;\n}*/\n\n.ui.menu .dropdown.item .menu {\n    background: #fff!important;\n    margin-top: 17px;\n    width: 250px;\n}\n.ui.menu .dropdown.item .menu.visible{\n    padding: 0px 10px 10px 15px !important;\n}\n\n.ui.menu .dropdown.item .menu.visible.multi-column-menu{\n    display: flex !important;\n    width: 520px !important;\n    flex-flow: wrap;\n    padding: 10px 0px 20px 20px !important;\n}\n\n.ui.menu .dropdown.item .menu.visible.flex-menu{\n    display: flex !important;\n    width: 520px !important;\n    flex-direction: row;\n    padding: 10px 0px 20px 20px !important;\n}\n.ui.menu .dropdown.item .menu.visible.flex-menu>.left{\n    display: flex !important;\n    flex-direction: column;\n    margin-top: -10px;\n}\n\n.ui.menu .dropdown.item .menu.visible.multi-column-menu .custom-msg-nav{\n    width: 210px !important;\n}\n\n.ui.menu .ui.dropdown .menu>.item {\n    font-size: 13px !important;\n    padding: 10px !important;\n    background: 0 0!important;\n    color: #fff !important;\n    font-weight: 500!important;\n    margin-right: 20px;\n}\n\n.ui.secondary.menu .dropdown.item>.menu {\n    border-radius: 0px;\n    border: unset;\n    transition: all 0.3s ease-in-out 0s, visibility 0s linear 0.3s, z-index 0s linear 0.01s;\n}\n\n.ui.menu .ui.dropdown .menu>.item:hover {\n    background: #fff !important;\n    color: #fff !important;\n    border-radius: 0 !important;\n}\n.ui.menu .ui.dropdown .menu>.left>.item:hover {\n    background: #fff !important;\n    color: #fff !important;\n    border-radius: 0 !important;\n}\n.ui.menu .ui.dropdown .menu>.right>.item:hover {\n    background: #fff !important;\n    color: #fff !important;\n    border-radius: 0 !important;\n}\n.ui.menu .ui.dropdown .menu>.active.item{\n/*    background: #FD7603 !important;*/\n    font-weight: 700 !important;\n    color: #fff !important;\n    border-radius: 0 !important;\n}\n\n.ui.menu .ui.dropdown .menu>.left>.active.item {\n/*    background: #FD7603 !important;*/\n    font-weight: 700 !important;\n    color: #fff !important;\n    border-radius: 0 !important;\n}\n\n.ui.menu .ui.dropdown .menu>.right>.active.item {\n/*    background: #FD7603 !important;*/\n    font-weight: 700 !important;\n    color: #fff !important;\n    border-radius: 0 !important;\n}\n\n\n.ui.menu .ui.dropdown .menu>.active.item > .custom-msg-nav>.content>.header {\n    color: #fd7603 !important;\n}\n\n.ui.menu .ui.dropdown .menu>.left>.active.item > .custom-msg-nav>.content>.header {\n    color: #fd7603 !important;\n}\n.ui.menu .ui.dropdown .menu>.right>.active.item > .custom-msg-nav>.content>.header {\n    color: #fd7603 !important;\n}\n\n.ui.secondary.inverted.menu a.item.contact-us {\n    color: #fff !important;\n    font-weight: 700px !important;\n}\n\n.ui.secondary.inverted.menu a.item.contact-us:hover {\n    color: #F9FBFF !important;\n    background-color: #FD7603 !important;\n}\n\n.ui.secondary.inverted.menu .active.item >.ui.item.dropdown{\n    color: #e85726 !important;\n}\n.ui.inverted.menu .item>.nav-list-text:before{\n    background-color: #fafaf9;\n    content: \"\";\n    position: absolute;\n    border-radius: 3px;\n    width: calc(100% - 20px);\n    height: calc(100% - 10px);\n    top: 5px;\n    left: 10px;\n    background: #edf1f2;\n    z-index: -1;\n    opacity: 0;\n    transform: scale(1.1);\n    transition: opacity .2s ease-in-out,transform .2s ease-in-out;\n}\n\n/*.ui.inverted.menu .item>.nav-list-text:focus,\n.ui.inverted.menu .item>.nav-list-text:before {\n    opacity: 1;\n    transform: scale(1);\n}*/\n\n\n.ui.item.dropdown.menu-item:after {\n    content: '';\n    display: block;\n    margin: auto;\n    height: 3px;\n    width: 0px;\n    margin-top: 10px;\n    margin-bottom: -12px;\n    background: transparent;\n    transition: width .5s ease, background-color .5s ease;\n}\n.ui.active.visible.item.dropdown.menu-item:after {\n    width: 100%;\n    background: #fd7603;\n}\n.ui.menu .item>i.dropdown.icon {\n    float: right;\n    margin-left: 5px !important;\n}\n\n.ui.menu .item>i.icon {\n    opacity: .75;\n    float: none;\n    margin: 0 15px 0 0;\n}\n\n.icon-menu-list, .mobile-view{\n    display: none;\n}\n\n.animate {\n  -webkit-animation-duration: 0.4s;\n  animation-duration: 0.4s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translateX(300px);\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 20);\n    transform: translate3d(0, -100%, 20);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 20);\n    transform: translate3d(0, -100%, 20);\n  }\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n\n\n.custom-msg-nav{\n    background: #fff !important;\n    box-shadow: unset !important;\n    transform: scale(1.1);\n    transition: opacity 80ms linear,transform 80ms ease-in;\n    padding: 10px;\n    width: 200px;\n    word-wrap: break-word;\n    white-space: pre-wrap;\n}\n.custom-msg-nav>.content>.header{\n    font-size: 14px !important;\n    margin-bottom: 0px !important;\n}\n.custom-msg-nav>.content>p{\n    display: inline-block !important;\n    font-size: 12px !important;\n    font-weight: 400 !important;\n    line-height: 1.6 !important;\n    color: #222b37 !important;\n}\n.custom-msg-nav>.content:before{\n    content: \"\";\n    position: absolute;\n    border-radius: 3px;\n    width: calc(100% + 8px);\n    height: calc(100% + 8px);\n    top: -4px;\n    left: -4px;\n    background: #fafaf9;\n    z-index: -1;\n    opacity: 0;\n    transform: scale(1.1);\n    transition: opacity 80ms linear,transform 80ms ease-in;\n}\n\n.custom-msg-nav>.content:hover:before {\n    opacity: 1;\n    transform: scale(1);\n    transition: opacity .2s linear,transform .2s ease-out;\n}\n.custom-msg-nav>.content:hover>.header{\n    color: #fd7603 !important;\n}\n.navigation__scrim.active {\n    opacity: 0.2;\n    pointer-events: all;\n}\n\n.ui.secondary.inverted.menu .active.dropdown.menu-item{\n    color: #e85726 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
